let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7FBC0")).then(() => parcelRequire('ca9jh'));